import React from 'react';
import { SITE_CONTENT } from '../data/siteContent';

export default function Footer() {
  return (
    <footer className="relative w-full mt-6 pb-5">
      <div className="text-center text-[#8a6b52] font-serif-display italic text-[0.95rem] tracking-wide">
        {SITE_CONTENT.footer}
      </div>
      <div className="mt-4 h-[3px] w-full bg-gradient-to-r from-[#cdb2e0] via-[#b89dd4] to-[#7a5aa2]" />
    </footer>
  );
}
